import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcab() {



const cardData =
{
  keyword: 'Pune to Bhimashankar Cab',

  heading: 'Lotus Cab: Pune to Bhimashankar Cab',

headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Bhimashankar Cab services for Jyotirlinga Darshan, family pilgrimages, spiritual tours, weekend trips, group travel, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by experienced chauffeurs familiar with the Bhimashankar route. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe travel through the scenic Sahyadri hills, Lotus Cabs ensures a comfortable, peaceful, and hassle-free pilgrimage experience to Bhimashankar and nearby attractions.",

  top: 'Top Places to Visit in Bhimashankar with Lotus Cab',

 topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga Temple",
        description:
            "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and one of Maharashtra's most important pilgrimage destinations. Nestled amidst the lush Sahyadri Hills, the ancient temple attracts thousands of devotees throughout the year for darshan, Rudrabhishek, Mahashivratri celebrations, and spiritual retreats. Its serene surroundings and religious significance make it the highlight of every Pune to Bhimashankar journey."
    },
    {
        title: "Bhimashankar Wildlife Sanctuary",
        description:
            "Bhimashankar Wildlife Sanctuary surrounds the temple and is renowned for its dense forests, rich biodiversity, rare Indian Giant Squirrels, waterfalls, and scenic trekking trails. Nature lovers, wildlife enthusiasts, and photographers frequently explore this protected sanctuary while enjoying the peaceful environment of the Western Ghats."
    },
    {
        title: "Hanuman Lake",
        description:
            "Hanuman Lake is a tranquil waterbody located near the Bhimashankar Temple, offering visitors a peaceful place to relax after darshan. Surrounded by greenery and fresh mountain air, the lake is ideal for quiet reflection, photography, and enjoying the natural beauty of the region."
    },
    {
        title: "Gupt Bhimashankar",
        description:
            "Gupt Bhimashankar is a sacred site located deep within the forest where it is believed that the holy Bhima River originates. Pilgrims and trekking enthusiasts visit this peaceful location to experience its spiritual significance, natural surroundings, and unique connection to the Bhimashankar temple."
    },
    {
        title: "Nagphani Point",
        description:
            "Nagphani Point, also known as Cobra Point, is one of the highest viewpoints in the Bhimashankar region. The viewpoint offers breathtaking panoramic views of valleys, forests, and surrounding mountain ranges, making it a favorite destination for trekkers, photographers, and nature lovers."
    },
    {
        title: "Ahupe Ghat",
        description:
            "Ahupe Ghat is a scenic mountain pass known for its dramatic cliffs, mist-covered landscapes, and beautiful views of the Sahyadri ranges. During the monsoon season, the region transforms into a lush green paradise, attracting travelers looking for a memorable road trip from Pune."
    },
    {
        title: "Shidi Ghat",
        description:
            "Shidi Ghat is one of the most adventurous trekking routes leading to Bhimashankar and is popular among experienced trekkers. The trail passes through forests, rocky terrain, waterfalls, and breathtaking viewpoints, providing an exciting experience for adventure enthusiasts."
    },
    {
        title: "Kondhwal Waterfall",
        description:
            "Kondhwal Waterfall is a hidden natural attraction near Bhimashankar that becomes especially beautiful during the monsoon season. Surrounded by dense greenery, the waterfall offers a peaceful escape for families, photographers, and visitors looking to experience the untouched beauty of the Sahyadri Hills."
    },
    {
        title: "Malshej Ghat",
        description:
            "Malshej Ghat is one of Maharashtra's most scenic hill passes and is often combined with a Bhimashankar trip. Famous for waterfalls, misty mountains, winding roads, and monsoon landscapes, it is a perfect destination for nature lovers and road-trip enthusiasts."
    },
    {
        title: "Ozar Ganpati Temple",
        description:
            "Ozar Ganpati Temple, one of the revered Ashtavinayak temples, is located within driving distance of Bhimashankar and is often included in pilgrimage itineraries. Dedicated to Lord Ganesha, the temple is known for its beautiful architecture, peaceful atmosphere, and spiritual significance, making it an ideal addition to a religious journey from Pune."
    }
],

  "services": [
    {
      "name": "Pune to Bhimashankar Cab Service",
      "description": "Book Pune to Bhimashankar cab service for a safe and comfortable pilgrimage journey to the sacred Jyotirlinga temple. The route covers approximately 110 km and includes scenic ghat roads requiring experienced drivers. Vehicles available include AC sedan, Ertiga, Innova Crysta, and Tempo Traveller for family or group travel. The service supports one-way, round trip, and same-day return options based on darshan schedule. Transparent per km pricing ensures clear fare breakdown including driver allowance and toll details. Suitable for devotees, senior citizens, and family pilgrims seeking smooth spiritual travel."
    },
    {
      "name": "Pune to Bhimashankar Taxi Fare",
      "description": "Check updated Pune to Bhimashankar taxi fare based on vehicle category, travel duration, and trip type. Fare calculation follows per kilometer pricing with minimum daily usage for outstation travel. Sedan and SUV options offer different comfort and luggage capacities depending on group size. Clear billing structure includes base fare, driver charges, and applicable tolls. Advance fare estimation helps pilgrims plan their spiritual trip budget effectively."
    },
    {
      "name": "Pune to Bhimashankar One Day Tour Package",
      "description": "Choose Pune to Bhimashankar one day tour package ideal for same-day darshan and return travel. Early morning departure ensures timely temple visit and avoids peak rush hours. Comfortable AC vehicles provide smooth highway and ghat road travel. The package is suitable for families, office groups, and religious tours seeking efficient travel. Structured itinerary allows temple darshan, local sightseeing, and relaxed return to Pune."
    },
    {
      "name": "Pune to Bhimashankar Cab Package",
      "description": "Opt for Pune to Bhimashankar cab package designed for flexible darshan planning and comfortable temple visits. The package includes doorstep pickup from Pune city or PCMC area. Travelers can customize departure timing and waiting duration at temple premises. Ideal for weekend pilgrimage or spiritual retreats with family. Transparent pricing avoids hidden charges and ensures predictable travel cost."
    },
    {
      "name": "Pune to Bhimashankar Innova Crysta",
      "description": "Book Innova Crysta for Pune to Bhimashankar travel for enhanced comfort and spacious seating. Suitable for larger families and elderly devotees requiring smooth suspension on ghat roads. Premium interiors and luggage capacity make it ideal for group pilgrimage. Per km fare structure ensures clear pricing for round trip or one-way journeys."
    },
    {
      "name": "Pune to Bhimashankar Ertiga on Rent",
      "description": "Affordable Ertiga rental from Pune to Bhimashankar for small families and religious groups. Comfortable AC travel with adequate luggage space makes it ideal for day tours. Budget-friendly per km pricing helps manage pilgrimage expenses efficiently. Professional drivers ensure safe navigation on mountain routes."
    },
    {
      "name": "Pune to Bhimashankar Tempo Traveller",
      "description": "Tempo Traveller service for Pune to Bhimashankar ideal for larger pilgrimage groups and spiritual tours. Spacious seating and group-friendly design provide comfortable long-distance travel. Suitable for temple committees, corporate spiritual tours, and extended family visits. Clear fare calculation per kilometer ensures transparency for group travel planning."
    },
    {
      "name": "Outstation Cab Pune to Bhimashankar",
      "description": "Reliable outstation cab Pune to Bhimashankar offering flexible one-way and round-trip travel options. Experienced drivers familiar with forest and ghat road conditions ensure safe journey. Vehicles are regularly serviced for long-distance travel reliability. Transparent billing structure supports stress-free pilgrimage planning."
    }
  ],

  "tableData": [
    ["Pune to Bhimashankar Cab Service", "Pune to Bhimashankar Taxi Fare"],
    ["Pune to Bhimashankar One Day Tour Package", "Pune to Bhimashankar Cab Package"],
    ["Pune to Bhimashankar Innova Crysta", "Pune to Bhimashankar Ertiga on Rent"],
    ["Pune to Bhimashankar Tempo Traveller", "Outstation Cab Pune to Bhimashankar"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Dedicated Jyotirlinga Travel Service",
      "WhyChoosedescription": "Specialized service focused on Bhimashankar temple travel ensuring timely darshan and comfortable pilgrimage journey."
    },
    {
      "WhyChooseheading": "Experienced Ghat Road Drivers",
      "WhyChoosedescription": "Professional drivers trained for mountain and forest routes ensuring safe and smooth travel."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear fare breakdown including distance calculation, driver allowance, and toll charges."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Categories",
      "WhyChoosedescription": "Sedan, Ertiga, Innova Crysta, and Tempo Traveller options available based on group size."
    },
    {
      "WhyChooseheading": "Flexible One Day & Round Trip Options",
      "WhyChoosedescription": "Travel plan customizable for same-day darshan or relaxed round-trip pilgrimage."
    },
    {
      "WhyChooseheading": "Senior Citizen Friendly Travel",
      "WhyChoosedescription": "Comfortable seating and smooth suspension ideal for elderly devotees."
    },
    {
      "WhyChooseheading": "Well-Maintained AC Vehicles",
      "WhyChoosedescription": "Clean and serviced vehicles ensure reliable long-distance temple travel."
    },
    {
      "WhyChooseheading": "Easy Booking & 24/7 Support",
      "WhyChoosedescription": "Quick confirmation and continuous assistance for smooth spiritual travel planning."
    }
  ]
}




const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Bhimashankar cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Bhimashankar cab service for one-way and round trips with safe drivers and well-maintained vehicles suitable for hill routes.',
  },
  {
    question: 'What is the distance between Pune and Bhimashankar by cab?',
    answer: 'The distance from Pune to Bhimashankar is approximately 110–120 km depending on the route. The travel time usually takes around 3 to 4 hours.',
  },
  {
    question: 'What are the charges for Pune to Bhimashankar cab booking?',
    answer: 'Cab fare depends on vehicle type, trip duration, and whether it is a one-way or round trip. Lotus Cab provides transparent pricing with clear per km rates and no hidden charges.',
  },
  {
    question: 'Can I book a same-day return cab from Pune to Bhimashankar?',
    answer: 'Yes, we offer same-day return cab packages for Bhimashankar Darshan, ideal for devotees planning a quick temple visit.',
  },
  {
    question: 'Which vehicles are available for Bhimashankar trip from Pune?',
    answer: 'Lotus Cab provides Sedan cars like Dzire and Etios for small groups and SUVs like Ertiga and Innova Crysta for families and larger groups.',
  },
  {
    question: 'Is Bhimashankar cab service available during Shravan and Mahashivratri?',
    answer: 'Yes, we provide special cab services during peak pilgrimage seasons like Shravan month and Mahashivratri. Advance booking is recommended during these periods.',
  },
  {
    question: 'Are toll and parking charges included in Pune to Bhimashankar cab fare?',
    answer: 'Toll and parking charges are billed separately as per actuals. Lotus Cab maintains full transparency and informs customers before confirming the booking.',
  },
  {
    question: 'Are drivers experienced for ghat and forest routes?',
    answer: 'Yes, our drivers are experienced in handling ghat roads and forest routes, ensuring safe and comfortable travel to Bhimashankar.',
  },
  {
    question: 'Can senior citizens comfortably travel to Bhimashankar by cab?',
    answer: 'Absolutely. Our clean and spacious vehicles along with flexible halts make the Bhimashankar journey comfortable for senior citizens and families.',
  },
  {
    question: 'How can I book Pune to Bhimashankar cab with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, and vehicle preference with Lotus Cab to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Pawar',
    feedback: 'Booked Lotus Cab for Bhimashankar Darshan from Pune. The driver was punctual and drove safely through ghat roads. Very smooth and peaceful trip.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Kulkarni',
    feedback: 'Great experience with Lotus Cab for Pune to Bhimashankar. Clean vehicle, reasonable fare, and cooperative driver. Highly recommended for temple visits.',
    rating: 5,
  },
];







































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Bhimashankar Cab",
"image": "https://lotuscab.com/assets/images/pune-to-bhimashankar-cab.jpg",
"description": "Book Pune to Bhimashankar Cab with Lotus Cab for a safe, comfortable, and affordable pilgrimage journey. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6452"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-bhimashankar-cab"
}
};









  return (
    <div>
      
<Helmet>
  <title>Pune to Bhimashankar Cab | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Bhimashankar Cab with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, instant booking, and 24x7 customer support for a comfortable pilgrimage."
/>

<meta
 name="keywords"
 content="Pune to Bhimashankar Cab, Pune to Bhimashankar Taxi, Pune to Bhimashankar Cab Service, Pune to Bhimashankar Taxi Service, Bhimashankar Cab from Pune, One Way Cab Pune to Bhimashankar, Round Trip Cab Pune to Bhimashankar, Bhimashankar Jyotirlinga Cab, Pune to Bhimashankar Temple Taxi, Affordable Pune to Bhimashankar Cab, Cheap Pune to Bhimashankar Taxi, Online Pune to Bhimashankar Cab Booking, Sedan Cab Pune to Bhimashankar, SUV Cab Pune to Bhimashankar, Best Pune to Bhimashankar Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcab;